import { useQuery } from '@tanstack/react-query';
import { QueryKey } from 'types/query';
import { getIndeedJobsPayload } from './indeed.payloads';
import { IndeedJob, IndeedJobListMutationResponse } from './indeed.types';
import { useIndeedConfig } from './useIndeedConfig';
import { fetchIndeedGraphQL } from './utils';

export const useIndeedJobListQuery = () => {
  const indeedConfig = useIndeedConfig();

  return useQuery(
    [QueryKey.useIndeedJobListQuery],
    async (): Promise<IndeedJob[]> => {
      if (!indeedConfig.isLoggedIn) return [];

      try {
        const response: IndeedJobListMutationResponse = await fetchIndeedGraphQL(getIndeedJobsPayload(), indeedConfig);
        return response.data.findEmployerJobs.results.map((e) => ({
          default: false,
          key: e.employerJob.id,
          name: e.employerJob.jobData.title,
          description: e.employerJob.jobData.formattedDescription.htmlDescription,
          location: e.employerJob.jobData.advertisingLocations[0].location,
          status: e.employerJob.jobData.status === 'DELETED' ? 'CLOSED' : e.employerJob.jobData.status,
        }));
      } catch (error) {
        console.error('Failed to get Indeed jobs: ', error);
        return [];
      }
    },
    {
      enabled: indeedConfig.isLoggedIn,
      retry: 0,
      initialData: [],
      initialDataUpdatedAt: 0,
    },
  );
};
